import { createContext, useContext, useState, useCallback } from "react";

const LangContext = createContext();

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState("en");
  const toggle = useCallback(() => setLang((l) => (l === "en" ? "fr" : "en")), []);
  const tr = useCallback((obj) => (obj && typeof obj === "object" ? obj[lang] : obj), [lang]);
  return (
    <LangContext.Provider value={{ lang, setLang, toggle, tr }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
